// Local preview for the personal stack's existing bearer-token authorizer.
import "core-js/features/promise";
import { render } from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App from "../src/components/App";
import "@amzn/awsui-global-styles/global-styles.css";
import "../src/globalStyles.scss";
import { getMidwayJwtToken } from "../src/auth/MidwayJwtToken";
import { isLuscaApiUrl } from "../src/auth/midwayAuthorizerSession";
import {
  getAppSetting,
  IAppSettings,
  initializeAppSettings,
} from "../src/config/AppSettings";
import { applyLuscaTheme } from "../src/config/theme";
import { withDevUser } from "../src/helpers/devUser";

applyLuscaTheme();

(async () => {
  await getMidwayJwtToken();
  const settings = (await axios("/settings.json")).data as IAppSettings;
  if (settings.apiUrl !== "api.viomarc.people.amazon.dev") {
    throw new Error("This local preview is restricted to Marc's personal API.");
  }
  initializeAppSettings(settings);

  axios.interceptors.request.use(async (config) => {
    const apiHost = getAppSetting("apiUrl") as string;
    config.url = withDevUser(config.url, apiHost, window.location.search);
    if (isLuscaApiUrl(config.url, apiHost)) {
      config.headers = {
        ...config.headers,
        Authorization: `Bearer ${await getMidwayJwtToken()}`,
      };
      config.withCredentials = false;
    }
    return config;
  });

  render(
    <BrowserRouter>
      <App />
    </BrowserRouter>,
    document.querySelector("#app")
  );
})().catch(console.error);
